import { AdyenConfig } from '@models/venue/integrations/AdyenConfig'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { INTEGRATIONS_ADYEN_CONFIGS_URL } from '@utils/urls'

const fetchAdyenConfigs = (params: TableParams) =>
  SBAPI.FetchPaginated<AdyenConfig[]>(INTEGRATIONS_ADYEN_CONFIGS_URL, params)

const fetchAdyenConfigById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<AdyenConfig>(`${INTEGRATIONS_ADYEN_CONFIGS_URL}/${id}`, params)

const deleteAdyenConfig = (adyenConfig: AdyenConfig) =>
  SBAPI.Delete(`${INTEGRATIONS_ADYEN_CONFIGS_URL}/${adyenConfig.id}`)

export { deleteAdyenConfig, fetchAdyenConfigById, fetchAdyenConfigs }
